import * as ApplicationConstants from './Application';
import * as IdleMonitorConstants from './IdleMonitor';

const DOMAIN_NAME = 'application';

export default {
  DOMAIN_NAME,
  ApplicationConstants,
  IdleMonitorConstants,
};
